import {  Layout, Row, Col} from 'antd';
import React, { Component} from "react";
import {NavLink} from "react-router-dom";
import { withTranslation  } from 'react-i18next';


/** *
* *Footer used in all pages. It receives as param if it used in regular user view or admin/jury mode, for a propper link use
@param admin
@param jury
*/
class Foot extends Component {
  render() {
    const { Footer } = Layout;
    const t = this.props.t
    return (
        <Footer style={{backgroundColor:'#ef8031', position:'relative',bottom:'0px',left:'0px',right:'0px',flexShrink:0}}>
          <Row justify="center" align="middle" style={{ width:'100%', backgroundColor:'#ef8031',  marginBottom:'0px', bottom:'0px'}}>
            <Col xl={6} xs={24} sm={{span:6}}> <div style={{textAlign: 'center'}}>  <NavLink to={this.props.admin ? "culturasOriginarias/admin_bases":this.props.jury ? "/culturasOriginarias/jury_bases": "/culturasOriginarias/bases"} style={{color:'white'}}>{t("Convocatoria")}</NavLink> </div> </Col>
            <Col xl={4}xs={24} sm={{span:6}}> <div style={{textAlign: 'center'}}> <a style={{color:'white'}} href = "mailto: coa@casa.cult.cu">coa@casa.cult.cu</a></div></Col>
            <Col xl={{span:4, offset:2}} sm={{span:6}} xs={{span:24}} > <div style={{textAlign: 'center'}}><a style={{color:'white', textAlign: 'center'}} target="_blank" href="http://www.casadelasamericas.org/">{t("Sitio Oficial Casa de las Américas")}</a> </div></Col>
            <Col xl={4}xs={24}sm={{span:6}} > <div style={{textAlign: 'center'}}> <a style={{color:'white'}}target="_blank"  href="http://laventana.casa.cult.cu/"> La Ventana</a></div></Col>
            <Col xl={4} xs={24} sm={{span:24}}> <div style={{textAlign: 'center'}}> <NavLink to={this.props.admin ? "/culturasOriginarias/admin_terminos":this.props.jury ? "/culturasOriginarias/jury_terminos":"/culturasOriginarias/terminos"} style={{color:'white'}}>{t("Términos y condiciones de uso")}</NavLink> </div> </Col>
          </Row>
        </Footer>
    );
  }
}
export default withTranslation() (Foot);


